module.exports = __webpack_public_path__ + "2edb636528ebb60ba7cc312feafa13bd.MP3";